<template>
    <div class="d-flex justify-content-start mb-4">
        <core-number-input
            :label="$t('components.price.element.min-nights.label')"
            :amount.sync="initialAmount"
        ></core-number-input>
    </div>
</template>

<script>
export default {
  data () {
    return {
      initialAmount: parseInt(this.amount) || 0
    }
  },
  props: {
    amount: {
      default: 0,
      type: String | Number,
      required: false
    }
  },
  watch: {
    initialAmount (val) {
      this.$emit('update:amount', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/price/element/MinNights.vue